import { render, staticRenderFns } from "./FulfillmentDetail.vue?vue&type=template&id=07a6cb58&scoped=true&"
import script from "./FulfillmentDetail.vue?vue&type=script&lang=js&"
export * from "./FulfillmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6cb58",
  null
  
)

export default component.exports